/* ============================================
   TGShopify Theme — app.js
   Client-side filtering, search, cart, mobile menu
   ============================================ */

(function () {
  'use strict';

  /* --- Tag Filtering --- */
  function initTagFilter() {
    var filterContainer = document.getElementById('tag-filter');
    var grid = document.getElementById('plugin-grid');
    if (!filterContainer || !grid) return;

    var buttons = filterContainer.querySelectorAll('.tag-filter-btn');
    var cards = grid.querySelectorAll('.plugin-card');
    var activeTag = 'all';

    function applyFilters() {
      var searchTerm = getSearchTerm();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matchesTag = activeTag === 'all' || cardMatchesTag(card, activeTag);
        var matchesSearch = !searchTerm || cardMatchesSearch(card, searchTerm);
        var visible = matchesTag && matchesSearch;

        card.classList.toggle('hidden', !visible);
        if (visible) visibleCount++;
      });

      toggleNoResults(visibleCount === 0 && (activeTag !== 'all' || searchTerm));
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeTag = btn.getAttribute('data-tag');

        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        applyFilters();
        updateHash(activeTag);
      });
    });

    // Restore from URL hash
    var hash = window.location.hash.slice(1);
    if (hash) {
      var target = filterContainer.querySelector('[data-tag="' + hash + '"]');
      if (target) {
        activeTag = hash;
        buttons.forEach(function (b) { b.classList.remove('active'); });
        target.classList.add('active');
        applyFilters();
      }
    }

    // Expose for combined filtering
    window._tgApplyFilters = applyFilters;
    window._tgGetActiveTag = function () { return activeTag; };
  }

  function cardMatchesTag(card, tag) {
    var tags = (card.getAttribute('data-tags') || '').toLowerCase().split(',');
    return tags.some(function (t) {
      return t.trim().replace(/\s+/g, '-') === tag;
    });
  }

  function updateHash(tag) {
    if (tag === 'all') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    } else {
      history.replaceState(null, '', '#' + tag);
    }
  }

  /* --- Search --- */
  function initSearch() {
    var searchInput = document.getElementById('plugin-search');
    if (!searchInput) return;

    var debounceTimer;

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (window._tgApplyFilters) {
          window._tgApplyFilters();
        } else {
          filterBySearchOnly();
        }
        // GA4: track search queries
        var term = searchInput.value.trim();
        if (term.length >= 2 && typeof gtag === 'function') {
          gtag('event', 'site_search', {
            search_term: term
          });
        }
      }, 300);
    });
  }

  function getSearchTerm() {
    var input = document.getElementById('plugin-search');
    return input ? input.value.trim().toLowerCase() : '';
  }

  function cardMatchesSearch(card, term) {
    var title = card.querySelector('.plugin-card-title');
    var titleText = title ? title.textContent.toLowerCase() : '';
    var tags = (card.getAttribute('data-tags') || '').toLowerCase();
    return titleText.indexOf(term) !== -1 || tags.indexOf(term) !== -1;
  }

  function filterBySearchOnly() {
    var grid = document.getElementById('plugin-grid');
    if (!grid) return;

    var cards = grid.querySelectorAll('.plugin-card');
    var term = getSearchTerm();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var visible = !term || cardMatchesSearch(card, term);
      card.classList.toggle('hidden', !visible);
      if (visible) visibleCount++;
    });

    toggleNoResults(visibleCount === 0 && term);
  }

  function toggleNoResults(show) {
    var msg = document.getElementById('no-results');
    if (msg) {
      msg.style.display = show ? 'block' : 'none';
    }
  }

  /* --- Cart AJAX --- */
  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('plugin-add-to-cart')) return;

      var submitBtn = form.querySelector('[data-add-to-cart]');
      if (!submitBtn) return;

      e.preventDefault();

      var formData = new FormData(form);
      var data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1
      };

      submitBtn.disabled = true;
      var originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function (item) {
          submitBtn.textContent = 'Added!';
          updateCartCount();
          // GA4: track add-to-cart with source page
          if (typeof gtag === 'function') {
            var productTitle = document.querySelector('.plugin-detail-title');
            gtag('event', 'add_to_cart_source', {
              product_name: productTitle ? productTitle.textContent.trim() : (item.title || ''),
              page_path: window.location.pathname,
              referrer: document.referrer
            });
          }
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          submitBtn.textContent = 'Error';
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () {});
  }

  /* --- Mobile Menu --- */
  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var nav = document.querySelector('.header-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      nav.classList.toggle('open');
    });

    // Close on link click
    nav.querySelectorAll('.nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('open');
      });
    });
  }

  /* --- Sort --- */
  function initSort() {
    var select = document.getElementById('sort-by');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* --- Sticky Cart Bar --- */
  function initStickyCart() {
    var bar = document.getElementById('sticky-cart-bar');
    var addBtn = document.querySelector('.plugin-add-to-cart [data-add-to-cart]');
    var footer = document.querySelector('.site-footer');
    if (!bar || !addBtn) return;

    var btnHidden = false;
    var footerVisible = false;

    function updateBar() {
      var show = btnHidden && !footerVisible;
      bar.classList.toggle('visible', show);
      bar.setAttribute('aria-hidden', !show);
    }

    var btnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        btnHidden = !entry.isIntersecting;
        updateBar();
      });
    }, { threshold: 0 });

    btnObserver.observe(addBtn);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
          updateBar();
        });
      }, { threshold: 0 });

      footerObserver.observe(footer);
    }
  }

  /* --- Blog article redirect (discussion comments land here after POST) --- */
  (function() {
    var path = window.location.pathname;
    var hash = window.location.hash || '';
    // Redirect from blog article page to product page
    var blogMatch = path.match(/^\/blogs\/discussions\/(.+)/);
    if (blogMatch) {
      var slug = blogMatch[1].replace(/\/$/, '');
      window.location.replace('/products/' + slug + '#comment-submitted');
      return;
    }
    // Fix wrong redirect from cached section: /products/discussions/slug → /products/slug
    var badMatch = path.match(/^\/products\/discussions\/(.+)/);
    if (badMatch) {
      var slug = badMatch[1].replace(/\/$/, '');
      window.location.replace('/products/' + slug + (hash || '#comment-submitted'));
      return;
    }
  })();

  /* --- Discussions --- */
  function initDiscussions() {
    var section = document.querySelector('.discussions-section');
    if (!section) return;

    var handle = section.getAttribute('data-product-handle');
    var textarea = document.getElementById('comment-body');
    var counter = document.querySelector('.discussions-char-count');

    if (textarea && counter) {
      textarea.addEventListener('input', function () {
        counter.textContent = textarea.value.length;
      });
    }

    // Show success message if redirected back after comment submission
    if (window.location.hash === '#comment-submitted') {
      var wrapper = document.querySelector('.discussions-form-wrapper');
      if (wrapper) {
        var msg = document.createElement('div');
        msg.className = 'discussion-message discussion-message--success';
        msg.textContent = 'Your comment has been posted!';
        wrapper.insertBefore(msg, wrapper.firstChild);
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    // Fetch comments from article page
    if (handle) {
      fetch('/blogs/discussions/' + handle + '?view=comments')
        .then(function(res) { return res.text(); })
        .then(function(text) {
          try {
            var data = JSON.parse(text.trim());
            renderComments(data);
            addDiscussionShortcut(data.count);
          } catch (e) {}
        })
        .catch(function() {});
    }
  }

  function addDiscussionShortcut(count) {
    var reviewsLink = document.querySelector('.plugin-detail-reviews-link');
    if (!reviewsLink) return;
    // Don't add twice
    if (document.querySelector('.plugin-detail-discussions-link')) return;

    var link = document.createElement('a');
    link.href = '#discussions';
    link.className = 'plugin-detail-discussions-link';
    link.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> ' +
      'Discussion' + (count > 0 ? ' (' + count + ')' : '');
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector('.discussions-section');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
    reviewsLink.parentNode.insertBefore(link, reviewsLink.nextSibling);
  }

  function renderComments(data) {
    var list = document.querySelector('.discussions-list');
    var countEl = document.querySelector('.discussions-count');
    var emptyEl = document.querySelector('.discussions-empty');
    if (!list) return;

    if (data.count === 0 || !data.comments || data.comments.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
      return;
    }

    if (countEl) {
      countEl.textContent = '(' + data.count + ')';
      countEl.style.display = '';
    }

    var html = '';
    data.comments.forEach(function(c) {
      var isDev = c.email === data.shop_email;
      html += '<div class="discussion-comment">';
      html += '<div class="discussion-comment-header">';
      html += '<span class="discussion-comment-author">' + escapeHtml(c.author) + '</span>';
      if (isDev) {
        html += '<span class="discussion-developer-badge">Developer</span>';
      }
      html += '<span class="discussion-comment-date">' + escapeHtml(c.date) + '</span>';
      html += '<button class="discussion-reply-btn" data-author="' + escapeHtml(c.author) + '">Reply</button>';
      html += '</div>';
      html += '<div class="discussion-comment-body">' + c.body + '</div>';
      html += '</div>';
    });
    list.innerHTML = html;

    // Bind reply buttons
    list.querySelectorAll('.discussion-reply-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var author = btn.getAttribute('data-author');
        var textarea = document.getElementById('comment-body');
        var form = document.querySelector('.discussions-form-wrapper');
        if (textarea && form) {
          textarea.value = '@' + author + ' ';
          textarea.focus();
          form.scrollIntoView({ behavior: 'smooth' });
          // Update char counter
          var counter = document.querySelector('.discussions-char-count');
          if (counter) counter.textContent = textarea.value.length;
        }
      });
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* --- Lightbox --- */
  function initLightbox() {
    var lightbox = document.getElementById('lightbox');
    var dataEl = document.getElementById('lightbox-data');
    if (!lightbox || !dataEl) return;

    var images;
    try { images = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!images.length) return;

    var img = lightbox.querySelector('.lightbox-img');
    var counter = lightbox.querySelector('.lightbox-counter');
    var currentIndex = 0;
    var triggerEl = null;

    var focusableSelector = '.lightbox-close, .lightbox-prev, .lightbox-next';

    function preload(index) {
      var i = (index % images.length + images.length) % images.length;
      if (!images[i]._preloaded) {
        var p = new Image();
        p.src = images[i].src;
        images[i]._preloaded = true;
      }
    }

    function show(index) {
      currentIndex = index;
      img.classList.add('loading');
      img.onload = function () { img.classList.remove('loading'); };
      img.src = images[index].src;
      img.alt = images[index].alt;
      counter.textContent = (index + 1) + ' / ' + images.length;

      // Preload neighbors
      preload(index - 1);
      preload(index + 1);

      lightbox.removeAttribute('hidden');
      // Force reflow before adding active class for transition
      void lightbox.offsetHeight;
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      lightbox.querySelector('.lightbox-close').focus();
    }

    function hide() {
      lightbox.classList.remove('active');
      setTimeout(function () {
        lightbox.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (triggerEl) { triggerEl.focus(); triggerEl = null; }
      }, 250);
    }

    function prev() {
      show((currentIndex - 1 + images.length) % images.length);
    }

    function next() {
      show((currentIndex + 1) % images.length);
    }

    // Trigger buttons
    document.querySelectorAll('.lightbox-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        triggerEl = btn;
        var idx = parseInt(btn.getAttribute('data-lightbox-index'), 10) || 0;
        show(idx);
      });
    });

    // Close buttons (close + backdrop)
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', hide);
    });

    lightbox.querySelector('.lightbox-prev').addEventListener('click', prev);
    lightbox.querySelector('.lightbox-next').addEventListener('click', next);

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (lightbox.hasAttribute('hidden')) return;

      if (e.key === 'Escape') { hide(); }
      else if (e.key === 'ArrowLeft') { prev(); }
      else if (e.key === 'ArrowRight') { next(); }
      else if (e.key === 'Tab') {
        // Focus trap
        var focusable = lightbox.querySelectorAll(focusableSelector);
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });
  }

  /* --- GA4 Custom Event Tracking --- */
  function initGA4Tracking() {
    if (typeof gtag !== 'function') return;

    // Track homepage section visibility (scroll depth)
    var sections = document.querySelectorAll('[data-track-section]');
    if (sections.length) {
      var seen = {};
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var name = entry.target.getAttribute('data-track-section');
          if (seen[name]) return;
          seen[name] = true;
          gtag('event', 'section_view', {
            section_name: name,
            page_path: window.location.pathname
          });
        });
      }, { threshold: 0.25 });

      sections.forEach(function (el) { sectionObserver.observe(el); });
    }

    // Track product card clicks with source context
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.plugin-card');
      if (!card) return;
      var section = card.closest('[data-track-section]');
      var sectionName = section ? section.getAttribute('data-track-section') : 'collection';
      var title = card.querySelector('.plugin-card-title');
      gtag('event', 'product_card_click', {
        product_name: title ? title.textContent.trim() : '',
        source_section: sectionName,
        page_path: window.location.pathname
      });
    });

    // Track hero CTA click
    var heroCta = document.querySelector('.hero-cta');
    if (heroCta) {
      heroCta.addEventListener('click', function () {
        gtag('event', 'hero_cta_click', {
          destination: heroCta.getAttribute('href')
        });
      });
    }

    // Track outbound link clicks
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '/' || href.charAt(0) === '#') return;
      try {
        var url = new URL(href, window.location.origin);
        if (url.hostname === window.location.hostname) return;
        gtag('event', 'outbound_click', {
          link_url: href,
          link_text: link.textContent.trim().substring(0, 100),
          page_path: window.location.pathname
        });
      } catch (err) {}
    });
  }

  /* --- Table of contents ---
     Builds an on-page TOC for any [data-toc] element from the headings inside
     the element named by data-toc-source. Shared by docs and guides so there
     is one implementation rather than a copy per template. */
  function initTableOfContents() {
    var tocs = document.querySelectorAll('[data-toc][data-toc-source]');
    Array.prototype.forEach.call(tocs, function (toc) {
      var content = document.getElementById(toc.getAttribute('data-toc-source'));
      var list = toc.querySelector('[data-toc-list]');
      if (!content || !list) return;

      var headings = content.querySelectorAll('h2, h3');
      if (headings.length < 3) return; // not worth a TOC

      var usedIds = {};
      Array.prototype.forEach.call(headings, function (h, i) {
        if (!h.id) {
          var base = h.textContent.trim().toLowerCase()
            .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section-' + i;
          var id = base, n = 2;
          while (usedIds[id] || document.getElementById(id)) { id = base + '-' + n++; }
          h.id = id;
        }
        usedIds[h.id] = true;

        var li = document.createElement('li');
        li.className = 'article-toc-item' + (h.tagName === 'H3' ? ' article-toc-item--sub' : '');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });

      toc.hidden = false;
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function () {
    initTagFilter();
    initSearch();
    initSort();
    initCart();
    initMobileMenu();
    initStickyCart();
    initDiscussions();
    initLightbox();
    initGA4Tracking();
    initTableOfContents();
  });
})();
